import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { DefaultOptionType, SelectProps } from "antd/lib/select";
import { useGetVehicleModels } from "../../../../common/api/queries/enumerations";
import type { UUID } from "../../../../typings/global";
import { VEHICLE_OTHER_MAPPING_NAME } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
  brandId?: UUID;
  onChangeIsOther?: (isOther: boolean) => void;
}

export const VehicleModelSelect = ({ formItemProps, selectProps, brandId, onChangeIsOther }: Props) => {
  const { data, isFetching } = useGetVehicleModels(brandId);

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={data?.map((model) => ({
          value: model.id,
          label: model.name,
        }))}
        loading={isFetching}
        onChange={(value, option?: DefaultOptionType) => {
          onChangeIsOther?.(option?.label === VEHICLE_OTHER_MAPPING_NAME);
          selectProps?.onChange?.(value, option);
        }}
        labelRender={(item) => item.label ?? ""}
      />
    </Form.Item>
  );
};
